import { render, staticRenderFns } from "./ScorecardRound.vue?vue&type=template&id=037507cb&scoped=true"
import script from "./ScorecardRound.vue?vue&type=script&lang=js"
export * from "./ScorecardRound.vue?vue&type=script&lang=js"
import style0 from "./ScorecardRound.vue?vue&type=style&index=0&id=037507cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037507cb",
  null
  
)

export default component.exports